import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SisLoader from "../../../../../widgets/loader";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../../utils/ResponseConver";
import {  NitrogenPlantCom } from "../../components/CargoMachinCom/NitrogenPlant";

export const NitrogenPlantListCom = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [Nitrogen_Plant_Data, set_Nitrogen_Plan_Data] = useState([]);

  const GET_SHIP_LNG_LISTS = async (ship_id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.list_nitrogen_info_machinery_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const updatedData = res.nitrogen_parameters_data.map((item) => ({
            ...item,
          }));

          const updatedDataWithFormattedParams = updatedData.map((item) => ({
            ...item,
            selected_parameters: updateSelectedParameters(item?.selected_parameters),
          }));

          set_loader(false);
          set_Nitrogen_Plan_Data(updatedDataWithFormattedParams);
        }
      });

      set_loader(false);
    } catch (error) {
      set_loader(false);
      console.error("Error BWT list:", error);
    }
  };


  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    GET_SHIP_LNG_LISTS(ship_id);
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {Nitrogen_Plant_Data && Nitrogen_Plant_Data?.length > 0 ? (
              <>
                {Nitrogen_Plant_Data?.map((_items) => (
                  <NitrogenPlantCom
                    key={_items.id} // add key for performance
                    eng_log_basic_id={eng_log_basic_id}
                    _items={_items}
                  />
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};
